"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.wrapWagtailIcon = exports.EmbedBlock = exports.ImageBlock = exports.Document = exports.Link = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var draftail_1 = require("draftail");
var wagtailConfig_1 = require("../../config/wagtailConfig");
var Icon_1 = __importDefault(require("../Icon/Icon"));
var Link_1 = require("./decorators/Link");
__createBinding(exports, Link_1, "default", "Link");
var Document_1 = require("./decorators/Document");
__createBinding(exports, Document_1, "default", "Document");
var ImageBlock_1 = require("./blocks/ImageBlock");
__createBinding(exports, ImageBlock_1, "default", "ImageBlock");
var EmbedBlock_1 = require("./blocks/EmbedBlock");
__createBinding(exports, EmbedBlock_1, "default", "EmbedBlock");
var ModalWorkflowSource_1 = __importDefault(require("./sources/ModalWorkflowSource"));
var Tooltip_1 = __importDefault(require("./Tooltip/Tooltip"));
var TooltipEntity_1 = __importDefault(require("./decorators/TooltipEntity"));
var EditorFallback_1 = __importDefault(require("./EditorFallback/EditorFallback"));
// 1024x1024 SVG path rendering of the "↵" character, that renders badly in MS Edge.
var BR_ICON = 'M.436 633.471l296.897-296.898v241.823h616.586V94.117h109.517v593.796H297.333v242.456z';
/**
 * Registry for client-side code of Draftail plugins.
 */
var PLUGINS = {};
var registerPlugin = function (plugin) {
    PLUGINS[plugin.type] = plugin;
    return PLUGINS;
};
/**
 * Wraps a style/block/entity type’s icon with an icon font implementation,
 * so Draftail can use icon fonts in its toolbar.
 */
exports.wrapWagtailIcon = function (type) {
    var isIconFont = type.icon && typeof type.icon === 'string';
    if (isIconFont) {
        return Object.assign(type, {
            icon: react_1["default"].createElement(Icon_1["default"], { name: type.icon }),
        });
    }
    return type;
};
/**
 * Initialises the DraftailEditor for a given field.
 * @param {string} selector
 * @param {Object} options
 * @param {Element} currentScript
 */
var initEditor = function (selector, options, currentScript) {
    // document.currentScript is not available in IE11. Use a fallback instead.
    var context = currentScript ? currentScript.parentNode : document.body;
    // If the field is not in the current context, look for it in the whole body.
    // Fallback for sequence.js jQuery eval-ed scripts running in document.head.
    var field = context.querySelector(selector) || document.body.querySelector(selector);
    var editorWrapper = document.createElement('div');
    editorWrapper.className = 'Draftail-Editor__wrapper';
    editorWrapper.setAttribute('data-draftail-editor-wrapper', true);
    field.parentNode.appendChild(editorWrapper);
    var serialiseInputValue = function (rawContentState) {
        field.rawContentState = rawContentState;
        field.value = JSON.stringify(rawContentState);
    };
    var blockTypes = options.blockTypes || [];
    var inlineStyles = options.inlineStyles || [];
    var entityTypes = options.entityTypes || [];
    entityTypes = entityTypes.map(exports.wrapWagtailIcon).map(function (type) {
        var plugin = PLUGINS[type.type];
        // Override the properties defined in the JS plugin: Python should be the source of truth.
        return Object.assign({}, plugin, type);
    });
    var enableHorizontalRule = options.enableHorizontalRule ? {
        description: wagtailConfig_1.STRINGS.HORIZONTAL_LINE,
    } : false;
    var rawContentState = JSON.parse(field.value);
    field.rawContentState = rawContentState;
    var editorRef = function (ref) {
        // Bind editor instance to its field so it can be accessed imperatively elsewhere.
        field.draftailEditor = ref;
    };
    var editor = (react_1["default"].createElement(EditorFallback_1["default"], { field: field },
        react_1["default"].createElement(draftail_1.DraftailEditor, __assign({ ref: editorRef, rawContentState: rawContentState, onSave: serialiseInputValue, placeholder: wagtailConfig_1.STRINGS.WRITE_HERE, spellCheck: true, enableLineBreak: {
                description: wagtailConfig_1.STRINGS.LINE_BREAK,
                icon: BR_ICON,
            }, showUndoControl: { description: wagtailConfig_1.STRINGS.UNDO }, showRedoControl: { description: wagtailConfig_1.STRINGS.REDO }, maxListNesting: 4, 
            // Draft.js + IE 11 presents some issues with pasting rich text. Disable rich paste there.
            stripPastedStyles: wagtailConfig_1.IS_IE11 }, options, { blockTypes: blockTypes.map(exports.wrapWagtailIcon), inlineStyles: inlineStyles.map(exports.wrapWagtailIcon), entityTypes: entityTypes, enableHorizontalRule: enableHorizontalRule }))));
    react_dom_1["default"].render(editor, editorWrapper);
};
exports["default"] = {
    initEditor: initEditor,
    registerPlugin: registerPlugin,
    // Components exposed for third-party reuse.
    ModalWorkflowSource: ModalWorkflowSource_1["default"],
    Tooltip: Tooltip_1["default"],
    TooltipEntity: TooltipEntity_1["default"],
};
